const productionApiBase = '/api/v1';
const developmentApiBase = 'http://localhost:4000/api/v1';

export const apiBase = (process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' ? productionApiBase : developmentApiBase)).replace(/\/$/, '');
